import { FooterStyled, Description, Icons, End, SocialMedia, Theme } from "./styles"
import arrayIcon from "./arrayIcon";
import { useContext } from "react";
import { ThemeSiteContext } from "../../context/ThemeContext";

import sun from "../../assets/sun.png"
import moon from "../../assets/moon.png"








export default function Footer(props) {
  const { theme} = useContext(ThemeSiteContext)


  return (
    <FooterStyled id="footer">
      <Description>
        <h2>Networking</h2>
        <p>
          Você pode me enviar um email ou conversar diretamente através das
          minhas redes.
        </p>
      </Description>

      <Icons>

        {arrayIcon.map(icon => <SocialMedia
          path={icon.url}
          key={icon.name}
          href={icon.link}
          target="_blank"
          rel="noreferrer">

          <button>
            {icon.name}
          </button>

        </SocialMedia>)}
      </Icons>


      <Theme    >

        <label
          htmlFor="choice">
          Temas

        </label>

        <span  >
          <img src={sun} alt="sol" />
        </span>

        <input type="range"
          max="1"
          id="choice"
          onChange={theme.handleToggleTheme}
          value={theme.themeSite === "dark" ? 1 : 0}

        />

        <span  >
          <img src={moon} alt="lua" />
        </span>

      </Theme>




      <End>

        <a href="#header">
          <button>
            <span></span>Voltar ao topo
          </button>
        </a>


        <p>Wellington Eduardo © 2022</p>

      </End>




    </FooterStyled>
  );
}
